'use strict';

var razorpaycancelApi = require('./razorpayCacelApi.js');

/**
 * Creates Razorpay payment options.
 * @param {string} callbackurl - The callback URL where the payment response will be sent.
 * @param {string} razorpaycancelurl - The URL to handle payment cancellation.
 * @param {Object} data - The data object containing Razorpay configuration and customer details.
 * @param {string} razorpayredirecturl - The URL for redirection after payment completion.
 * @returns {Object} The Razorpay payment options object.
 */
function createRazorPayOptions(callbackurl, razorpaycancelurl, data, razorpayredirecturl) {
    var razorPayObject = JSON.parse(data.razorPayOptionObject);
    var options = {};
    if (razorPayObject) {
        options = {
            key: data.siteprefvalues.secretKeyID, // Enter the Key ID generated from the Dashboard
            amount: razorPayObject.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: razorPayObject.currency,
            name: data.siteprefvalues.name, // your business name
            description: data.siteprefvalues.description,
            image: data.siteprefvalues.images,
            order_id: razorPayObject.id, // This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            callback_url: callbackurl,
            prefill: { // We recommend using the prefill parameter to auto-fill customer's contact information especially their phone number
                name: data.customerProfile.customerName, // your customer's name
                email: data.customerProfile.customeremail,
                contact: data.customerProfile.customerPhoneNo // Provide the customer's phone number for better conversion rates
            },
            notes: {
                address: 'Razorpay Corporate Office',
                wcsOrderId: razorPayObject.receipt
            },
            modal: {
                ondismiss: function (razorpayData) {
                    razorpaycancelApi.callDismissalHandler(razorpayData, razorpaycancelurl, razorpayredirecturl);
                }
            },
            theme: {
                color: '#3399cc'
            }
        };
    }
    return options;
}
module.exports = {
    createRazorPayOptions: createRazorPayOptions
};
